import React, { useEffect, useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import {
  useGetPackingSummaryQuery,
  useGetRefrigerationDataQuery,
} from "../packing/packingApi";
import Box from "../../../images/boxes.svg";
import BoxGreen from "../../../images/box_green.svg";
import BoxOrange from "../../../images/box_orange.svg";
import RefrigerationOrange from "../../../images/refrigeration_orange.svg";
import Datatable from "../../../components/shared/datatable/Datatable";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import Button from "../../../components/shared/buttons/button";
import { format } from "date-fns";
import RefrigerationModal from "./RefrigerationModal";
import useTranslator from "../../../hooks/useTranslator";
import moment from "moment";
import { convertToUserTimezone, formatDateAndTime, formatPalletName, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";

const Refrigeration = () => {
  const { _t } = useTranslator();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [modalMode, setModalMode] = useState("add");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [addRecord, setAddRecord] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [lotNumber , setLotNumber] = useState(getCurrentDate("DDMMYY"));

  const { data: summaryData } = useGetPackingSummaryQuery({
    tab: "refrigeration",
    date,
  });
  const { data: refrigerationData, isLoading: isRefrigerationLoading, isFetching: isRefrigerationFetching } = useGetRefrigerationDataQuery({
    date,
  });
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleAddRefrigerationData = () => {
    setAddRecord(true);
    setModalMode("add");
    setSelectedRecord(null);
    setShowModal(true);
  };

  useEffect( () => {
    setLotNumber(convertToUserTimezone(date, "DDMMYY"));
  },[date]);

  const listItems = [
    {
      label: _t("refrigeration_total_boxes_on_floor", "Total boxes on Floor"),
      value: summaryData?.data.total_boxes_on_floor,
      icon: BoxGreen,
    },
    {
      label: _t("prime_cheek_boxes_10_pund", "Prime Cheek Boxes (10 pounds)"),
      value: summaryData?.data.total_refrigration_prime_cheek_boxes_10_pound,
      icon: Box,
    },
    {
      label: _t("prime_cheek_boxes_20_pund", "Prime Cheek Boxes (20 pounds)"),
      value: summaryData?.data.total_refrigration_prime_cheek_boxes_20_pound,
      icon: Box,
    },
    {
      label: _t("prime_strip_boxes_10_pund", "Prime Strip Boxes (10 pounds)"),
      value: summaryData?.data.total_refrigration_prime_strip_boxes_10_pound,
      icon: Box,
    },
    {
      label: _t("prime_strip_boxes_20_pund", "Prime Strip Boxes (20 pounds)"),
      value: summaryData?.data.total_refrigration_prime_strip_boxes_20_pound,
      icon: Box,
    },

    {
      label: _t("refrigeration_boxes_in_refrigerator", "Boxes in Refrigerator"),
      value: summaryData?.data.total_boxes_in_refrigerator,
      icon: BoxOrange,
    },
  ];

  const formatDateTime = (dateTime) => {
    if (!dateTime) return "";

    const utcDate = new Date(dateTime + "Z");

    return format(utcDate, "yyyy-MM-dd/HH:mm");
  };

  const handleEdit = (data) => {
    setAddRecord(true);
    setModalMode("edit");
    setSelectedRecord(data);
    setShowModal(true);
  };
  const columns = [
    {
      label: _t("refrigeration_date", "Date"),
      accessor: "created_at",
      cell: ({ value }) => {
        // const arr = value.split(" ");
        // return arr[0];
        // return value;
        return convertToUserTimezone(value);
      },
    },
    {
      label: _t("batch_code", "Batch Code"),
      accessor: "lot_number_id",
      cell : ({value}) => {
        return <span className="cmn_badge active"> {value} </span>;
      }
    },
    {
      label: _t("refrigeration_pallet_number", "Pallet Number"),
      accessor: "pallet_number",
      cell: ({ value }) => formatPalletName(value),
    },
    {
      label: _t("refrigeration_fruit_type", "Fruit Type"),
      accessor: "fruit_type",
    },
   
    // :::::::::::::::::::::::::::::::::::
    {
      label: _t("prime_cheek_10_pund", "Prime Cheek (10 pounds)"),
      accessor: "prime_cheek_boxes_10_pound",
    },
    {
      label: _t("prime_cheek_20_pund", "Prime Cheek (20 pounds)"),
      accessor: "prime_cheek_boxes_20_pound",
    },
    // {
    //   label: _t( "prime_strip_10_pund","Prime Strip (10 pounds)"),
    //   accessor: "prime_strip_boxes_10_pound",
    // },
    {
      label: _t("prime_strip_20_pund", "Prime Strip (20 pounds)" ),
      accessor: "prime_strip_boxes_20_pound",
    },
    // :::::::::::::::::::::::::::::::::::
    {
      label: _t("total_boxes", "Total Boxes"),
      accessor: "number_of_box",
    },
    {
      label: _t("refrigeration_status", "Status"),
      accessor: "status",
      cell: ({ value }) => (
        <span className={value === "sold" ? "cmn_badge" : "cmn_badge inactive"}>
          {value === "sold" ? _t("refrigeration_status_sold", "Sold") : _t("refrigeration_status_stored", "Stored")}
        </span>
      ),
    },

    {
      label: _t("refrigeration_actions", "Edit/Processing"),
      accessor: "status",
      cell: ({ row }) => (
        <>
          {row.status === "stored" ? (
            <Button
              size="small"
              label={_t("refrigeration_edit", "Edit")}
              className="borderRedBtn"
              onClick={() => handleEdit(row)}
            />
          ) : (
            <span>{formatDateTime(row.sold_at)}</span>
          )}
        </>
      ),
    },
  ];
  return (
    <div>
      {addRecord && (
        <RefrigerationModal
          show={showModal}
          setShow={setAddRecord}
          mode={modalMode}
          record={selectedRecord}
          lot_number_id={lotNumber}
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1"> {_t("refrigeration_title", "Refrigeration Overview")}</h6>
          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("common.today", "Today") : formatDateAndTime(date,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      <Datatable
        title={_t("refrigeration_logs_title", "Refrigeration Logs")}
        columns={columns}
        tableData={refrigerationData?.data}
        onPageChangenPageChange={handlePageChange}
        page={page}
        buttons={[
          {
            label: _t("refrigeration_add_data", "Add Refrigeration Data"),
            onClick: handleAddRefrigerationData,
            icon: PlusSvg,
          },
        ]}
        isLoading={isRefrigerationLoading || isRefrigerationFetching}  
      />
    </div>
  );
};

export default Refrigeration;
